module.exports = __webpack_public_path__ + "static/media/Kemampuan.bd9e3835.svg";